<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('停水开始时间')" prop="stopWaterBegin">
                <a-date-picker v-model="model.stopWaterBegin" show-time :placeholder="$t('请选择停水开始时间')" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%;" :disabled-date="disabledDate" @change="onCalendarChange" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('停水结束时间')" prop="stopWaterEnd">
                <a-date-picker v-model="model.stopWaterEnd" show-time :placeholder="$t('请选择停水结束时间')" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%;" :disabled-date="disabledDate2" @change="onCalendarChange2" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('影响范围')" prop="stopWaterRange">
                <a-textarea v-model="model.stopWaterRange" :placeholder="$t('请输入影响范围')" :rows="3"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('停水原因')" prop="stopWaterCause">
                <a-textarea v-model="model.stopWaterCause" :placeholder="$t('请输入停水原因')" :rows="4" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import moment from 'moment';
  export default {
    mixins: [JeecgListMixin],
    name: 'modal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-charge/oa/oaStopWaterInformation/add",
          edit: "/jeecg-charge/oa/oaStopWaterInformation/edit",
          queryById: "/jeecg-charge/oa/oaStopWaterInformation/queryById",
          list: "null",
        },
        disabledCurrentStart: null,
        disabledCurrentEnd: null,
      }
    },
    computed: {
      validatorRules() {
        return {
          stopWaterBegin: [{
            required: true,
            message: this.$t('请选择停水开始时间'),
            trigger: 'change'
          }],
          stopWaterEnd: [{
            required: true,
            message: this.$t('请选择停水结束时间'),
            trigger: 'change'
          }],
          stopWaterRange: [{
            required: true,
            message: this.$t('请输入停水范围'),
            trigger: 'blur'
          }],
          stopWaterCause: [{
            required: true,
            message: this.$t('请输入停水原因'),
            trigger: 'blur'
          }],
        }
      },
    },
    methods: {
      init(row,type){
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        if(type == 'edit'){
          this.title = this.$t('编辑');
          this.disableSubmit = false;
        }else if(type == 'detail'){
          this.title = this.$t('详情');
          this.disableSubmit = true;
        }else{
          this.title = this.$t('新增');
          this.disableSubmit = false;
        }
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.disabledCurrentStart = null
        this.disabledCurrentEnd = null
        this.close()
      },
      handleOk(){
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.close();
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      disabledDate(current) {
          return current > moment(this.disabledCurrentEnd) // 大于当前日期不能选
      },
      disabledDate2(current) {
          return current < moment(this.disabledCurrentStart) // 小于当前日期不能选
      },
      onCalendarChange(value, mode) {
          this.disabledCurrentStart = mode
      },
      onCalendarChange2(value, mode) {
          this.disabledCurrentEnd = mode
      },
    }
  }
</script>